import React, { useEffect } from "react";
import "./css/Contact.css";

export default function Contact() {
  useEffect(() => {
    document.title = "Contact | My MLM Website";
  }, []);
  return (
    <div className="contact-container">
      <h1 className="contact-heading">Contact Us</h1>
      <p className="contact-description">
        अगर आप हमारी MLM services या leads के बारे में जानना चाहते हैं, तो नीचे
        form भरकर हमसे संपर्क करें। हम जल्द ही reply करेंगे।
      </p>

      <form className="contact-form">
        <div className="form-group">
          <label>Name</label>
          <input type="text" placeholder="Enter your name" required />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input type="email" placeholder="Enter your email" required />
        </div>

        <div className="form-group">
          <label>Phone</label>
          <input type="tel" placeholder="Enter your phone number" required />
        </div>

        <div className="form-group">
          <label>Message</label>
          <textarea
            placeholder="Write your message"
            rows="5"
            required></textarea>
        </div>

        <button type="submit" className="contact-btn">
          Send Message
        </button>
      </form>
    </div>
  );
}
